import EventEmitter from "events";
import { Notification, NotificationSource } from "../models/Notification";
import { RoomSetting } from "../models/User";

export class MyNotifs {
  static NotificationsByMessage = new Map<string, Notification>(); // message.id, Notification
  static NotificationsByRoom = new Map<string, Notification[]>(); // room.id, Notification
  static Notifications: Notification[] = [];
  static NotificationsUpdatedEmitter = new EventEmitter(); // 'updated'
  static NrOfNew = 0;
  static NrOfNewLastChange = 0;

  /**
   * 알림을 사용자에게 "노출"(전역/워크스페이스 벨 뱃지 + 알림 모달 + 좌측 채널 목록 unread)할지 판정.
   * functions `_onCreateNotificationTrigger` 의 푸시 억제 조건과 동일하게 맞춘다:
   *  - 채널 음소거(disablePushNotifications) 채널 알림 제외 (단 멘션+멘션허용은 노출)
   *  - 외부 API 알림 비활성화(disableExternalNotifications) 채널의 외부 메시지(isExternal) 알림 제외
   *  - 캘린더 리마인더(직접 건 알림)는 항상 노출
   * ※ 표시 시점 필터라, 오래된 메시지로 isNew 가 안 지워져도(stuck) 애초에 노출되지 않는다.
   */
  static isVisibleInCenter(n: Notification, roomSettings: Map<string, RoomSetting>): boolean {
    if (n.type === 'CalendarEvent') return true; // 직접 건 리마인더 — 음소거 무관
    // 음소거/외부 판정 대상: 채팅=roomId, 채널 게시판/태스크=channelId (둘 다 채널 단위)
    const muteRoomId = n.roomId ?? n.channelId ?? null;
    if (!muteRoomId) return true;
    const rs = roomSettings.get(muteRoomId);
    // 외부 API 알림 비활성화: 외부(webhook/API) 메시지 알림 제외 (음소거와 별개 토글)
    if ((n as any).isExternal && rs?.disableExternalNotifications) return false;
    if (!rs?.disablePushNotifications) return true;
    // 음소거 채널이라도 멘션 + 멘션 허용이면 노출(푸시와 동일)
    return !!(n.isMentioned && rs.allowMentionPushNotifications);
  }

  static setNotifications(notifs: Notification[], roomSettings: Map<string, RoomSetting>) {
    this.NotificationsByMessage.clear();
    this.NotificationsByRoom.clear();
    this.Notifications = notifs;
    let _nrOfNew = notifs.filter(n => n.isNew && MyNotifs.isVisibleInCenter(n, roomSettings)).length;
    this.NrOfNewLastChange = _nrOfNew - this.NrOfNew;
    this.NrOfNew = _nrOfNew;

    notifs.forEach(n => {
      if (n.messageId) {
        this.NotificationsByMessage.set(n.messageId, n)
      }
      if (n.roomId) {
        if (!this.NotificationsByRoom.get(n.roomId)) {
          this.NotificationsByRoom.set(n.roomId, []);
        }
        this.NotificationsByRoom.get(n.roomId)?.push(n);
      }
    });
    this.NotificationsUpdatedEmitter.emit('updated', notifs);
  }

  static subscribeToNotificationUpdates(handler: (notifs: Notification[]) => void): () => void {
    MyNotifs.NotificationsUpdatedEmitter.on('updated', handler);
    handler(this.Notifications);
    return () => MyNotifs.NotificationsUpdatedEmitter.removeListener('updated', handler);
  }

  /** 통지 소스 (enrich 필드 우선, 구 데이터는 type 으로 폴백) — 게시판/캘린더 탭 필터·아이콘에 사용 */
  static sourceOf(n: Notification): NotificationSource {
    if (n.source) return n.source;
    if (n.type === 'BoardPost') return 'board';
    if (n.type === 'CalendarEvent') return 'calendar';
    return 'chat';
  }

  /** 채널 ID (enrich 필드 우선, 구 데이터는 roomId 폴백) — 채널 탭 필터·라우팅에 사용 */
  static channelIdOf(n: Notification): string | null {
    return n.channelId ?? n.roomId ?? null;
  }
}

MyNotifs.NotificationsUpdatedEmitter.setMaxListeners(100);


  // static getNrOfNewFromUser(userId: string, roomId: string) {
  //   return (this.NotificationsByUser.get(userId) ?? []).filter(n => n.messageId && n.isNew && n.roomId == roomId).length;
  // }